export default __webpack_public_path__ + "static/media/image9.9a8f194e.png";